export default __webpack_public_path__ + "static/media/dropdownLogout.f50ccfb5.svg";